module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-Regular-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-Regular-webfont.eot
// module id = 353
// module chunks = 0